import tinycolor from 'tinycolor2';

export const changeColorAlpha = (color: string, amount: number) =>
  tinycolor(color)
    .setAlpha(Math.min(tinycolor(color).getAlpha() + amount, 1))
    .toString();
